export default __webpack_public_path__ + "static/media/play.bdbcfd3a.svg";